<template>
  <v-container fluid>
    <h3
      class="primary--text text-xs-left mt-4 mb-4"
    >If the answer is “Yes” to any of the following questions, please provide detailed Information.</h3>
    <v-layout>
      <v-flex xs12>
        <v-radio-group
          required
          :rules="[rules.HaveLicenseEverBeenSuspendedRevoked]"
          row
          v-model="GeneralQuestions.HaveLicenseEverBeenSuspendedRevoked"
          label="Has your license ever been suspended or revoked?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="GeneralQuestions.HaveLicenseEverBeenSuspendedRevoked ==true">
        <v-textarea
          required
          :rules="[rules.SelectYesinFluent]"
          box
          name="input-7-1"
          autoGrow
          label="Please provide additional information"
          v-model="GeneralQuestions.IfYesExplainLicenseSuspendedOrRevoked"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-radio-group
          required
          :rules="[rules.ProfessionalDispendPendingAgainstYou]"
          row
          v-model="GeneralQuestions.ProfessionalDispendPendingAgainstYou"
          label="Are there any professional disciplinary actions pending against you?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="GeneralQuestions.ProfessionalDispendPendingAgainstYou ==true">
        <v-textarea
          required
          :rules="[rules.SelectYesinFluent]"
          auto-grow
          box
          label="Please provide additional information"
          v-model="GeneralQuestions.IfYesProfessionalDispendPendingAgainstYou"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          required
          :rules="[rules.AnyRestrictionsOnYourLicense]"
          row
          v-model="GeneralQuestions.AnyRestrictionsOnYourLicense"
          label="Are there any restrictions on your license?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 v-if="GeneralQuestions.AnyRestrictionsOnYourLicense ==true">
        <v-textarea
          required
          :rules="[rules.SelectYesinFluent]"
          auto-grow
          box
          label="Please provide additional information"
          v-model="GeneralQuestions.IfyesExplainAnyRestrictionsOnYourLicense"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          required
          :rules="[rules.HaveYourConvictedoforPledguiltyUnderFederalLaw]"
          row
          v-model="GeneralQuestions.HaveYourConvictedoforPledguiltyUnderFederalLaw"
          label="Have you ever been convicted of or pled guilty to a felony as defined under federal or state law?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="GeneralQuestions.HaveYourConvictedoforPledguiltyUnderFederalLaw ==true">
        <v-textarea
          required
          :rules="[rules.SelectYesinFluent]"
          auto-grow
          box
          label="Please provide additional information"
          v-model="GeneralQuestions.IfYesHaveYourConvictedoforPledguiltyUnderFederalLaw"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          required
          :rules="[rules.ObligationNotCompletedWYSLRPService]"
          row
          v-model="GeneralQuestions.ObligationNotCompletedWYSLRPService"
          label="Do you have an existing service obligation that will not be completed by the beginning of your WY-SLRP service obligation period?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="GeneralQuestions.ObligationNotCompletedWYSLRPService ==true">
        <v-textarea
          required
          :rules="[rules.SelectYesinFluent]"
          auto-grow
          box
          label="Please provide additional information"
          v-model="GeneralQuestions.IfYesObligationNotCompletedWYSLRPService"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          required
          :rules="[rules.DefaultAnyEducationalLoans]"
          row
          v-model="GeneralQuestions.DefaultAnyEducationalLoans"
          label="Are you in default on any educational loans?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="GeneralQuestions.DefaultAnyEducationalLoans ==true">
        <v-textarea
          required
          :rules="[rules.SelectYesinFluent]"
          auto-grow
          box
          label="Please provide additional information"
          v-model="GeneralQuestions.IfYesDefaultAnyEducationalLoans"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          required
          :rules="[rules.JudgmentLienAgainstPropertyForDebtToUS]"
          row
          v-model="GeneralQuestions.JudgmentLienAgainstPropertyForDebtToUS"
          label="Have you ever had a judgment lien against your property for a debt to the United States?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="GeneralQuestions.JudgmentLienAgainstPropertyForDebtToUS ==true">
        <v-textarea
          required
          :rules="[rules.SelectYesinFluent]"
          auto-grow
          box
          label="Please provide additional information"
          v-model="GeneralQuestions.IfYesJudgmentLienAgainstPropertyForDebtToUS"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs11>
        <v-radio-group
          required
          :rules="[rules.DefaultFederalPayObligations]"
          row
          v-model="GeneralQuestions.DefaultFederalPayObligations"
          label="Have you ever defaulted on any federal payment obligations? (HEAL, Nursing Student Loans, federal income tax liability, FHA loans, etc.)"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="GeneralQuestions.DefaultFederalPayObligations ==true">
        <v-textarea
          required
          :rules="[rules.SelectYesinFluent]"
          auto-grow
          box
          label="Please provide additional information"
          v-model="GeneralQuestions.IfYesDefaultFederalPayObligations"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          required
          :rules="[rules.ReachedPriorServiceObligationToGovOrEntity]"
          row
          v-model="GeneralQuestions.ReachedPriorServiceObligationToGovOrEntity"
          label="Have you ever breached a prior service obligation to the federal/state/local government or other entity, even if you have subsequently satisfied the obligation?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="GeneralQuestions.ReachedPriorServiceObligationToGovOrEntity ==true">
        <v-textarea
          required
          :rules="[rules.SelectYesinFluent]"
          auto-grow
          box
          label="Please provide additional information"
          v-model="GeneralQuestions.IfYesReachedPriorServiceObligationToGovOrEntity"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          required
          :rules="[rules.FederalDebtWrittenOffAsUncollectible]"
          row
          v-model="GeneralQuestions.FederalDebtWrittenOffAsUncollectible"
          label="Have you ever had any federal debt written off as uncollectible or had any federal service or payment obligation waived?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="GeneralQuestions.FederalDebtWrittenOffAsUncollectible ==true">
        <v-textarea
          required
          :rules="[rules.SelectYesinFluent]"
          auto-grow
          box
          label="Please provide additional information"
          v-model="GeneralQuestions.IfFederalDebtWrittenOffAsUncollectible"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          required
          :rules="[rules.DoYouUnfulfilledChildSupportObligations]"
          row
          v-model="GeneralQuestions.DoYouUnfulfilledChildSupportObligations"
          label="Do you have any unfulfilled child support obligations?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="GeneralQuestions.DoYouUnfulfilledChildSupportObligations===true">
        <v-textarea
          required
          :rules="[rules.SelectYesNameOfChild]"
          auto-grow
          box
          label="Please provide name of child and name, address, and phone number of person to whom payment is mailed, and when this obligation will be completed."
          :readonly="disableFields"
          v-model="GeneralQuestions.IfYesNameOfchildAddressPhoneNumberAdditionalNotes"
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Rules from '../validation/rules'
export default {
  name: 'GeneralQuestion',
  props: {
    GeneralQuestions: Object,
    disableFields: Boolean
  },
  data() {
    return {
      rules: Rules,
    }
  },
  methods: {},
  components: {},
  watch: {
    GeneralQuestions: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
    },

  },
}
</script>
<style>
</style>